import clsx from 'clsx';
import type { ReactNode } from 'react';

import { SDSFlexbox } from '@repo/sds/SDSFlexbox';

import './settings-page-content.scss';

interface SettingsPageContentProps {
  children: ReactNode;
  wide?: boolean;
}

/**
 * Centers settings page sections and spaces stacked cards.
 */
export function SettingsPageContent({ children, wide = false }: SettingsPageContentProps) {
  return (
    <SDSFlexbox
      className={clsx('SettingsPageContent', wide && 'SettingsPageContent--wide')}
      direction="column"
      alignItems={wide ? 'stretch' : 'center'}
      gap="text-xx-large"
      fullHeight={wide}
      fullWidth
    >
      {children}
    </SDSFlexbox>
  );
}
